module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA8CAYAAAAt3km7AAAABHNCSVQICAgIfAhkiAAAAUBJREFUaIHt2s2NgzAUReFjJPpIKhnSBd0k6YYuxqmE6YOFswhPY80whD8PPOudVYJY8OnKOzuiuraucFz7vxVaCtwBynNzk0dOfnRf9SeaMEMF7oJzAF1b36KltOfLU3NxmaFeBS7F3t+QJMe1yG6tvjwXgypXWLaLGUxdBtOWwbRlMG0ZTFsG05bBtGUwbRlMWwbTlsG0ZTBtGUxbBtOWwbRlMG0VgN/7IxLk81ws8Cjkuk5uFeW58Vnh+mtH33epcrih8/MulaQY53uUlwdu6C1VwGiluEGYdHDgr5XiRmHQ415vHgU4CpLewqQDrDcJJE2GSbsA/zhHY82GSf8EnLVS3GIYJD1/i0HSKpi04XqrQdImMGkVcME5GmtTmDQTuNlKcUlgMOn8JQFJyWBS19YVUOH4ACDwAHwqUPY9AWfcf7PSDpyxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(8).png
// module id = 37bJ
// module chunks = 1